<template>
	<el-dialog
		title="支付设置"
		@close="$emit('close')"
		:visible="visibleInside"
		width="400px"
		v-loading="loading"
	>
		<el-row class="setting-item">
			<el-col :span="8">默认支付方式</el-col>
			<el-col :span="16">
				<el-switch
					style="display: block"
					v-model="default_pay"
					active-color="#409EFF"
					inactive-color="#13ce66"
					inactive-text="微信"
					active-text="支付宝"
					@change="val => handleChange(val, 'default_pay')"
				></el-switch>
			</el-col>
		</el-row>
		<el-row class="setting-item">
			<el-col :span="8">概率模式开关</el-col>
			<el-col :span="16">
				<el-switch
					style="display: block"
					v-model="probability_switch"
					active-text="开"
					inactive-text="关"
					@change="val => handleChange(val, 'probability_switch')"
				></el-switch>
			</el-col>
		</el-row>
		<el-row class="setting-item">
			<el-col :span="8">支付宝支付总开关</el-col>
			<el-col :span="16">
				<el-switch
					style="display: block"
					v-model="alipay_switch"
					active-text="开"
					inactive-text="关"
					@change="val => handleChange(val, 'alipay_switch')"
				></el-switch>
			</el-col>
		</el-row>
		<el-row class="setting-item">
			<el-col :span="8">微信支付总开关</el-col>
			<el-col :span="16">
				<el-switch
					style="display: block"
					v-model="wechat_switch"
					active-text="开"
					inactive-text="关"
					@change="val => handleChange(val, 'wechat_switch')"
				></el-switch>
			</el-col>
		</el-row>
		<el-row class="setting-item">
			<el-col :span="8">银联云闪付支付总开关</el-col>
			<el-col :span="16">
				<el-switch
					style="display: block"
					v-model="unionpay_switch"
					active-text="开"
					inactive-text="关"
					@change="val => handleChange(val, 'unionpay_switch')"
				></el-switch>
			</el-col>
		</el-row>
	</el-dialog>
</template>

<script>
import { patchData } from '../../http'
import { mapState } from 'vuex'
export default {
	data() {
		return {
			default_pay: false,
			probability_switch: false,
			alipay_switch: false,
			wechat_switch: false,
			unionpay_switch: false,
			loading: false
		}
	},
	props: {
		visible: Boolean
	},
	computed: {
		...mapState({
			paymentSetting: state => state.data.paymentSetting
		}),
		visibleInside: {
			get() {
				return this.visible
			},
			set() {}
		}
	},
	watch: {
		paymentSetting(val) {
			val.forEach(item => {
				let val
				if (item.config_value === 1 || item.config_value === '1') {
					val = true
				} else {
					val = false
				}
				switch (item.config_name) {
					case 'default_pay':
						this.default_pay = val
						break
					case 'probability_switch':
						this.probability_switch = val
						break
					case 'alipay_switch':
						this.alipay_switch = val
						break
					case 'wechat_switch':
						this.wechat_switch = val
						break
					case 'unionpay_switch':
						this.unionpay_switch = val
						break
					default:
						break
				}
			})
		}
	},
	methods: {
		handleChange(val, type) {
			this.loading = true
			if (val) {
				val = 1
			} else {
				val = 2
			}
			patchData('config', {
				config_name: type,
				config_value: val
			})
				.then(
					res => {
						this.$message.success('修改设置成功')
					}
				)
				.finally(() => {
					this.loading = false
				})
		}
	}
}
</script>

<style lang="less" scoped>
.setting-item {
	margin-bottom: 20px;
}
</style>
